import { AutoComplete as AutoCompleteA, type AutoCompleteProps } from 'antd';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { resolveClassNames } from '../utils';
import styles from './auto-complete.module.css';

export type AutoCompleteProperties<ValueType> = {
  fullWidth?: boolean;
} & AutoCompleteProps<ValueType>;

const AutoComplete = <ValueType,>({
  classNames,
  fullWidth,
  placeholder,
  ...props
}: AutoCompleteProperties<ValueType>) => {
  const { t } = useTranslation();

  return (
    <AutoCompleteA<ValueType>
      className={cn({
        [styles['full-width'] ?? '']: fullWidth,
      })}
      classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
        ...resolvedClassNames,
        popup: {
          ...resolvedClassNames?.popup,
          root: cn(resolvedClassNames?.popup?.root, styles.popup),
        },
      }))}
      placeholder={typeof placeholder === 'string' ? t(placeholder) : placeholder}
      size="large"
      {...props}
    />
  );
};

export default AutoComplete;
